import { memo, useState, type MouseEvent } from 'react'
import { Link } from 'react-router-dom'
import { Divider, IconButton, Menu } from '@mui/material'
import { handleLogout } from 'utils/handleLogout'
import * as Styled from './sidebar.styled'

import { IconLogOut01, IconUser01 } from 'assets/icons'

const SidebarUser = memo((): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const openMenu = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = (): void => {
    setAnchorEl(null)
  }

  const isMenuOpen = Boolean(anchorEl)

  return (
    <>
      <IconButton
        sx={{ svg: { width: '20px', height: '20px' } }}
        onClick={openMenu}
        aria-label="User account"
        {...(isMenuOpen && { 'aria-expanded': true, 'aria-controls': 'sidebar-user-menu' })}
      >
        {IconUser01}
      </IconButton>

      <Menu id="sidebar-user-menu" anchorEl={anchorEl} open={isMenuOpen} onClose={closeMenu} onClick={closeMenu}>
        <Styled.MenuItemUser component={Link} to="/account">
          {IconUser01} Account
        </Styled.MenuItemUser>
        <Divider />
        <Styled.MenuItemUser onClick={handleLogout}>{IconLogOut01} Logout</Styled.MenuItemUser>
      </Menu>
    </>
  )
})

SidebarUser.displayName = 'SidebarUser'

export { SidebarUser }
